<script lang="ts">
	import { page } from '$app/stores';
	import type { CourseLesson$result } from '$houdini';
	import { canUserAccessCourseLesson } from '$lib/service/authZ';
	import PlayerGuardOverlay from './Overlays/PlayerGuardOverlay.svelte';

	export let courseLesson: CourseLesson$result | null;
	export let lessonSlug: string;

	/** defines if user can access the lesson or not **/
	export let canAccess: boolean = false;

	/** set's the canAccess property **/
	$: if (courseLesson || $page.data.session) {
		try {
			canAccess = canUserAccessCourseLesson($page.data.session, courseLesson?.course, lessonSlug);
		} catch {
			canAccess = true;
		}
	}
</script>

{#if !canAccess}
	<div class="player-overlay-all z-index-video-guard-overlay">
		<PlayerGuardOverlay />
	</div>
{/if}
